import IntegrationMessageDetailPage from '../shared/IntegrationMessageDetailPage';

const InternalOutboxMessageDetailPage = () => (
    <IntegrationMessageDetailPage kind="internalOutbox" />
);

export default InternalOutboxMessageDetailPage;
